import { PingTreeReport } from "components/Report/PingTreeReport/PingTreeReport.tsx";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { PermissionEnum } from "types/enums.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute.ts";
import { getReportHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/report/_layout/pingtree/")({
    component: PingTreesReportPage,
    staticData: {
        permissions: [PermissionEnum.ReportCascade],
        showInSideMenu: false,
        label: "pages.report.pingtree.title",
    },
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.report.pingtree.title"),
        };
    },
});

function PingTreesReportPage() {
    return (
        <TenantPage headerNavigationItems={getReportHeaderItems}>
            <PingTreeReport />
        </TenantPage>
    );
}
